import { render, staticRenderFns } from "./ankn-url-schemes.vue?vue&type=template&id=35bf6ca4"
import script from "./ankn-url-schemes.vue?vue&type=script&lang=js"
export * from "./ankn-url-schemes.vue?vue&type=script&lang=js"
import style0 from "./ankn-url-schemes.vue?vue&type=style&index=0&id=35bf6ca4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports